import React from 'react';
import {
  Box,
  Typography,
  Button,
  Modal as MuiModal,
} from '@mui/material';
import MDButton from 'mdComponents/MDButton';

interface AlertProps {
  visible: boolean;
  onConfirm: () => void;  
}

const LocationAlreadyExistsModal: React.FC<AlertProps> = ({
  visible,
  onConfirm,
}) => {
  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 400,
          maxWidth: '90%',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" mb={1}>
          Location Already Exits!
        </Typography>

        <Typography variant="body2" mb={3}>
          There is already a location at this address! Please check the entered address.<br />If this is your business please contact us!
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <MDButton color="info" onClick={onConfirm}>
            Okay
          </MDButton>
        </Box>
      </Box>
    </MuiModal>
  );
};

export default LocationAlreadyExistsModal;
